import {
  Component, Input, ViewChild, AfterViewInit
} from '@angular/core';
import { Observable } from 'rxjs';

import { Patient } from '@sondermind/utilities/models-patient';
import { ProviderUser } from '@sondermind/utilities/models-user-provider';
import { IrisModalRef, IrisModalService, IrisModalSize } from '@sondermind/iris/modal';

import { EmbeddedClientCreatorComponent } from '../embedded-client-creator/embedded-client-creator.component';

@Component({
  selector: 'embedded-client-creator-dialog',
  templateUrl: './embedded-client-creator-dialog.component.html',
  styles: [],
  standalone: false
})
export class EmbeddedClientCreatorDialogComponent implements AfterViewInit {
  @Input() user: ProviderUser;

  saving = false;
  loaded = false;

  error_list: { [index: string]: any; } = {};
  system_errors: string[] = [];

  @ViewChild('patientModal') patientModal: EmbeddedClientCreatorComponent;

  constructor(
    private irisModalService: IrisModalService,
    public irisModalRef: IrisModalRef<EmbeddedClientCreatorComponent, { user: ProviderUser; patient: Patient; isOpened: boolean; }, boolean | Patient>,
  ) { }

  ngAfterViewInit(): void {
    this.loaded = true;
    setTimeout(() => {
      const firstInput = document.querySelector('input[formControlName="firstName"]') as HTMLInputElement;
      if (firstInput) {
        firstInput.focus();
      }
    });
  }

  open(patient: Patient): Observable<Patient> {
    return this.irisModalService.open<EmbeddedClientCreatorDialogComponent, { user: ProviderUser; patient: Patient; isOpened: boolean; }, Patient>(
      EmbeddedClientCreatorDialogComponent,
      {
        data: { user: this.user, patient, isOpened: true },
        size: IrisModalSize.MD,
      }
    ).afterClosed$();
  }

  get canSave(): boolean {
    return this.loaded && !this.saving && this.patientModal && this.patientModal.valid;
  }

  onCancel(): void {
    this.irisModalRef.close(null);
  }

  patientAdded(patient: Patient): void {
    this.irisModalRef.close(patient);
  }
}
